import { Box } from "@mui/material";
import { type ButtonProps } from "src/components-mui/base/button/button";
import { IWfPopoverSlotProps, WfPopover } from "src/components-mui/base/wf-popover/wf-popover";
import { ITooltip } from "src/types/common";
import { EnumTagColor } from "src/types/common-enum";
import { TagButton } from "./tag-button";

export interface ITag {
    label: string;
    color: EnumTagColor;
    isCrossedOut?: boolean;
    tooltip?: ITooltip | string;
    popoverSlotProps?: IWfPopoverSlotProps;
}

// Omit `color` from ButtonProps to avoid conflict
type TagProps = ITag & Omit<ButtonProps, "color">;

export function Tag({ label, color, tooltip, popoverSlotProps, isCrossedOut = false, sx, ...rest }: TagProps) {
    const showCrossedOut = isCrossedOut
        ? {
              textDecoration: "line-through",
              textDecorationThickness: 2,
              textDecorationColor: "text.primary",
          }
        : undefined;

    const popoverTrigger = (
        <TagButton color={color} sx={sx} {...rest}>
            <Box sx={showCrossedOut}>{label}</Box>
        </TagButton>
    );

    if (!tooltip) return popoverTrigger;

    if (typeof tooltip === "string") {
        return <WfPopover PopoverTrigger={popoverTrigger} content={tooltip} slotProps={popoverSlotProps} />;
    }

    return <WfPopover PopoverTrigger={popoverTrigger} content={tooltip.content} link={tooltip.link} slotProps={popoverSlotProps} />;
}
